import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Text from '../chrome/Text';
import Frame from '../chrome/Frame';
import Icon from '../chrome/Icon';
import Close from '../chrome/Close';

const baseStyles = ({ theme }) => css`
  background-color: ${theme.colors.red}; 
  color: ${theme.colors.white};
  width: 100%;
  padding ${theme.spacings.kilo} ${theme.spacings.mega};
  display: flex;
`;

const centeredStyles = ({ centered }) =>
  centered &&
  css`
    text-align: center;
  `;

const secondaryStyles = ({ theme, variant }) =>
  variant === 'secondary' &&
  css`
    background-color: ${theme.colors.bl900};
  `;

const tertiaryStyles = ({ theme, variant }) =>
  variant === 'tertiary' &&
  css`
    background-color: ${theme.colors.o300};
    color: ${theme.colors.black};
  `;

const Container = styled('div')(baseStyles, centeredStyles, secondaryStyles, tertiaryStyles);

const closeIconBaseStyles = () => css`
  margin-left: auto;
`;

const CloseIcon = styled('div')(closeIconBaseStyles);

const textWrapperBaseStyles = ({ theme }) => css`
  position: relative;
  width: 100%;

  span {
    border-bottom: 1px solid ${theme.colors.white};
  }
`;

const TextWrapper = styled('div')(textWrapperBaseStyles);

const iconWrapperBaseStyles = ({ theme }) => css`
  padding-left: ${theme.spacings.kilo};
`;

const IconWrapper = styled('div')(iconWrapperBaseStyles);

const spacerBaseStyles = () => css`
  visibility: hidden;
`;

const Spacer = styled('div')(spacerBaseStyles);

const NotificationBar = ({ centered, variant, title, text, size, icon, iconPrefix, hideIcon, onSelect }) => {
  const showSpacer = !hideIcon && centered;

  return (
    <Container centered={centered} variant={variant}>
      {showSpacer && <Spacer>Spacer</Spacer>}
      <TextWrapper>
        {title && (
          <Text as='h3' size={size || 'giga'} bold noMargin>
            {title}
          </Text>
        )}
        {text && (
          <Text as='p' size={size || 'giga'} noMargin>
            {text}
          </Text>
        )}
      </TextWrapper>
      {!hideIcon && (
        <IconWrapper>
          {icon ? (
            <Frame variant='whiteTransparent'>
              <Icon icon={icon} prefix={iconPrefix} />
            </Frame>
          ) : (
            <CloseIcon onClick={onSelect}>
              <Close />
            </CloseIcon>
          )}
        </IconWrapper>
      )}
    </Container>
  );
};

NotificationBar.propTypes = {
  centered: PropTypes.bool,
  variant: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  textLong: PropTypes.string,
  icon: PropTypes.string,
  iconPrefix: PropTypes.string,
  hideIcon: PropTypes.bool,
  size: PropTypes.string,
  onSelect: PropTypes.func,
};

NotificationBar.defaultProps = {
  centered: true,
  hideIcon: true,
};

export default NotificationBar;
